
// Application configuration settings

export const appConfig = {
  // Payment settings
  payment: {
    useMockPayment: true, // Set to false to use real payment processing
    mockRedirectDelay: 2000, // Delay in ms before redirecting in mock mode
  }
};
